// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./packages/drawer-wtp/index.scss
// module id = 5
// module chunks = 22